import { 
  doc, 
  setDoc, 
  getDoc, 
  serverTimestamp 
} from 'firebase/firestore';
import { db } from '../config/firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { storage } from '../config/firebase';

export const userService = {
  // Crear o actualizar perfil de usuario
  createUserProfile: async (userData) => {
    try {
      const userRef = doc(db, 'users', userData.uid);
      
      // Asegurarnos de que solo guardamos campos serializables
      const cleanUserData = {
        uid: userData.uid,
        email: userData.email,
        displayName: userData.displayName || '',
        photoURL: userData.photoURL || '',
        username: userData.username || '',
        bio: userData.bio || '',
        createdAt: serverTimestamp(),
        updatedAt: serverTimestamp()
      };

      await setDoc(userRef, cleanUserData);
      
      // Verificar que el perfil se creó correctamente
      const userDoc = await getDoc(userRef);
      if (!userDoc.exists()) {
        throw new Error('Error al crear el perfil de usuario');
      }
      
      return userDoc.data();
    } catch (error) {
      console.error('Error creating user profile:', error);
      throw error;
    }
  },

  // Obtener perfil de usuario
  getUserProfile: async (userId) => {
    try {
      const userRef = doc(db, 'users', userId);
      const userDoc = await getDoc(userRef);
      
      if (userDoc.exists()) {
        return userDoc.data();
      }
      return null;
    } catch (error) {
      console.error('Error getting user profile:', error);
      throw error;
    }
  },

  // Actualizar perfil de usuario
  updateUserProfile: async (userId, profileData) => {
    try {
      const userRef = doc(db, 'users', userId);
      await setDoc(userRef, {
        ...profileData,
        updatedAt: serverTimestamp(),
      }, { merge: true });
      
      return true;
    } catch (error) {
      console.error('Error updating user profile:', error);
      throw error;
    }
  },

  uploadProfilePhoto: async (userId, file) => {
    try {
      // Crear una referencia única para la imagen
      const storageRef = ref(storage, `users/${userId}/profile-photo-${Date.now()}`);
      
      // Subir el archivo
      const snapshot = await uploadBytes(storageRef, file);
      
      // Obtener la URL de descarga
      const photoURL = await getDownloadURL(snapshot.ref);
      
      // Actualizar el perfil del usuario con la nueva URL
      await userService.updateUserProfile(userId, { photoURL });
      
      return photoURL;
    } catch (error) {
      console.error('Error uploading profile photo:', error);
      throw error;
    }
  }
}; 